var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import Storage from 'helpers/Storage';
import { toDate, toDateTime, toRound } from '../../../helpers/Format';
import { T } from '../../../helpers/i18n';
import QRCodeSVG from '../../../elements/QRCode';
import { tramoHora } from '../containers/TicketSales';
import cxs from 'cxs/component';
import { TypeDiscount } from '../../DiscountReasons/IDiscount';
import { PaymentMethod } from '../../../Models/TicketPayment';
let Papel = class Papel extends Component {
    componentDidMount() {
        return __awaiter(this, void 0, void 0, function* () {
            const user_id = this.props.store.users.user.id;
            const caja = JSON.parse(Storage.get(user_id.toString()));
            // console.log ('Papel - componentDidMount() - caja: ', caja)
            const cashDeskTickets = (caja && caja.tickets) || [];
            // await this.props.store.stretchesStore.read()
        });
    }
    constructor(props) {
        super(props);
        // console.log('props', props)
    }
    render() {
        // const cashDeskTickets = this.props.store.cashDeskTicketStore.getTickets()
        let cashDeskTickets = [];
        if (this.props.location && this.props.location.state) {
            cashDeskTickets.push(this.props.location.state);
        }
        else {
            cashDeskTickets = this.props.store.cashDeskTicketStore.tickets;
        }
        // console.log('Papel - render() - cahsDeskTickets', cashDeskTickets)
        return (React.createElement(Wrapper, null, cashDeskTickets.map((item) => renderTicket(item, this.props.store.stretchesStore.findBusinessunitByStretchId(item.stretch_id)))));
    }
};
Papel = __decorate([
    inject('store'),
    observer
], Papel);
export default Papel;
const Wrapper = cxs('div')({});
export const renderTicket = (item, stretch) => {
    var _a;
    // console.log('businessunit: ', stretch)
    const image = stretch ? `${process.env.REACT_APP_SERVER}${stretch.operationLine.businessUnit.image}` : '';
    // console.log('image: ', image)
    const canceled = !!item.daterefund;
    return (React.createElement("div", { key: item.numero, style: {
            margin: 0,
            marginTop: '40px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            borderBottom: '3px dotted black',
            /*marginTop: 50,*/
            backgroundColor: 'white',
        } },
        React.createElement("img", { alt: 'image', width: '130px', src: image }),
        React.createElement("p", { style: { margin: 0 } }, `${T('sellBy')} ${item.username}`),
        React.createElement("p", null, toDateTime(item.datecheck)),
        !item.numberSI && React.createElement("h4", null, "TARJETA EMBARQUE"),
        item.numberSI && React.createElement("h4", null, item.numberSI),
        React.createElement("p", { style: {
                marginTop: '10px',
                width: '90%',
                height: '1px',
                background: 'black',
            } }, ''),
        React.createElement("div", { style: {
                width: '90%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'start',
                alignItems: 'flex-start',
            } },
            React.createElement("p", { style: { marginBottom: '1px' } }, item.operationLineName),
            React.createElement("p", { style: { marginTop: '1px' } }, item.stretchName)),
        React.createElement("p", { style: {
                width: '90%',
                height: '1px',
                background: 'black',
            } }, ''),
        item.lines.map(line => React.createElement("div", { key: line.id, style: {
                width: '90%',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
            } },
            React.createElement("p", { style: { width: '60px', } }, `${line.quantity}x`),
            React.createElement("p", { style: { width: '120px', } }, line.passengerCategoryName),
            React.createElement("p", { style: { textAlign: 'end', width: '100px', } }, toRound(line.total)))),
        React.createElement("p", { style: {
                marginBottom: '10px',
                width: '90%',
                height: '1px',
                background: 'black',
            } }, ''),
        React.createElement("div", { style: {
                width: '90%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-end',
            } },
            item.discount > 0 &&
                React.createElement("div", null,
                    React.createElement("p", { style: { margin: '0', padding: 0, textDecoration: 'line-through', fontWeight: 'normal', textAlign: 'end' } }, `Total  ${toRound((_a = item.total + item.totalDiscount) !== null && _a !== void 0 ? _a : 0)} ${item.money}`),
                    item.discountReason && React.createElement("p", { style: { margin: '0', padding: 0, textAlign: 'end' } }, `${T('discountReason')}: ${item.discountReason}`),
                    item.typeDiscount === TypeDiscount.Percentage && React.createElement("p", { style: { margin: '0', padding: 0, textAlign: 'end' } }, `Descuento: ${item.discount} % -${toRound(item.totalDiscount)} ${item.money}`),
                    item.typeDiscount === TypeDiscount.Fix && React.createElement("p", { style: { margin: '0', padding: 0, textAlign: 'end' } }, `Descuento: ${item.totalDiscount} ${item.money}`)),
            React.createElement("p", { style: { textDecoration: canceled ? 'line-through' : 'initial', margin: '0', padding: 0, fontWeight: 'bold', textAlign: 'end', } }, `Total  ${toRound(item.total)} ${item.money}`),
            React.createElement("p", { style: { textDecoration: canceled ? 'line-through' : 'initial', margin: '0', padding: 0, textAlign: 'end', } }, `${T(item.tipoPago ? item.tipoPago : PaymentMethod.Cash)}`),
            canceled && React.createElement("p", { style: { margin: '0', padding: 0, fontWeight: 'bold', textAlign: 'end' } }, T('canceled'))),
        React.createElement("p", { style: { textAlign: 'end', width: '100%', marginRight: '30px' } }, `${item.taxName} Incluido - ${item.tin}`),
        React.createElement("span", null, `${item.numero}`),
        React.createElement(QRCodeSVG, { value: item.numero, size: 100, level: 'H' }),
        React.createElement("p", { style: { marginTop: '10px' } }, "Gracias por su visita"),
        React.createElement("p", { style: { marginBottom: 0 } }, '**************************************'),
        renderExpiration(item),
        item.vuelta && !item.hoponHopoff && renderIdaVuelta(),
        !item.daterefund && item.datevalited && item.numberScanned === 1 && React.createElement("img", { style: {}, alt: 'image', width: '90x', src: '/assets/images/valited.jpeg' }),
        !item.daterefund && item.datevalited && item.numberScanned === 2 &&
            React.createElement("div", null,
                React.createElement("img", { style: {}, alt: 'image', width: '90px', src: '/assets/images/valited.jpeg' }),
                React.createElement("img", { style: {}, alt: 'image', width: '90px', src: '/assets/images/valited.jpeg' }))));
};
const renderExpiration = (item) => {
    const { timeExpiration, timeUse } = item;
    // console.log('dateExpiration', timeExpiration)
    const expiration = new Date(item.datevalited ? item.datevalited : item.datebook);
    if (item.hoponHopoff /*&& item.datevalited*/) {
        if (item.timeExpiration === 0) { // resto del día
            expiration.setHours(23);
            expiration.setMinutes(59);
            expiration.setSeconds(59);
            expiration.setMilliseconds(999);
        }
        else {
            if (!item.datevalited) {
                expiration.setDate(expiration.getDate() + item.timeExpiration);
                expiration.setHours(new Date(item.datecheck).getHours());
                expiration.setMinutes(new Date(item.datecheck).getMinutes());
                expiration.setHours(23);
                expiration.setMinutes(59);
                expiration.setSeconds(59);
            }
            else {
                const valited = new Date(item.datevalited);
                expiration.setHours(valited.getHours() + timeUse);
            }
        }
    }
    else {
        expiration.setHours(23, 59, 59, 999);
        expiration.setDate(expiration.getDate() + timeExpiration);
    }
    const book = item.datebook ? item.datebook : item.datecheck;
    // console.log('Papel - renderExpiration - timeExpiration: ', item.timeExpiration)
    if (item.tramoHora) {
        const dateToShow = item.datebookNTZ ? item.datebookNTZ : item.datebook;
        const tramoHorario = tramoHora(typeof dateToShow === 'string' ? new Date(dateToShow) : dateToShow, item.hours, item.minutes);
        if (item.vuelta) {
            return (React.createElement("div", { style: { marginTop: 0 } },
                React.createElement("h6", null,
                    React.createElement("p", { style: { textAlign: 'center' } }, 'Válido para un solo uso de ida y vuelta')),
                fechasIguales(typeof item.datebook === 'string' ? new Date(item.datebook) : item.datebook, expiration) && React.createElement("h6", null,
                    React.createElement("p", { style: { marginTop: 0, marginBottom: 0, textAlign: 'center' } },
                        T('parael'),
                        " ",
                        toDate(expiration))),
                !fechasIguales(typeof item.datebook === 'string' ? new Date(item.datebook) : item.datebook, expiration) && React.createElement("h6", null,
                    React.createElement("p", { style: { marginTop: 0, marginBottom: 0, textAlign: 'center' } },
                        T('desde'),
                        " ",
                        toDate(item.datebook),
                        " a las ",
                        tramoHorario,
                        " ",
                        React.createElement("br", null),
                        " ",
                        React.createElement("br", null),
                        " ",
                        T('hasta'),
                        " ",
                        toDate(expiration),
                        React.createElement("br", null)))));
        }
        return (React.createElement("div", { style: { marginTop: 0 } },
            React.createElement("h6", null,
                React.createElement("p", { style: { textAlign: 'center' } }, 'Válido para un solo uso')),
            !item.hoponHopoff && item.vuelta && React.createElement("h6", null,
                React.createElement("p", { style: { textAlign: 'center' } }, 'Válido para un solo uso de ida y vuelta')),
            React.createElement("h6", null,
                React.createElement("p", { style: { marginTop: 0, marginBottom: 0, textAlign: 'center' } },
                    toDate(item.datebook),
                    " a las ",
                    tramoHorario,
                    " horas"))));
    }
    else { // ticket normal o hoponhopoff
        // Si tiene datebook la expiración será la fecha del datebook más el timeUse, a no ser que timeExpiration sea 0 y entonces es el resto del día
        // Si tiene datebook y no datevalited la expiración será la caducidad, y si tiene datevalited sera la fecha del datebook más el timeUse,
        // a no ser que timeExpiration sea 0 y entonces es el resto del día
        // Si no tiene datebook se muestra el plazo para validarlo por primera vez
        return (React.createElement("div", { style: { marginTop: 0 } },
            item.hoponHopoff && React.createElement("h2", null,
                React.createElement("p", { style: { textAlign: 'center', marginBottom: 0 } }, 'HopON HopOFF')),
            " ",
            item.hoponHopoff && item.timeExpiration !== 0 && React.createElement("h6", null,
                React.createElement("p", { style: { textAlign: 'center', marginTop: 0 } }, `${item.timeUse} hora${item.timeUse === 1 ? '' : 's'} a partir de la hora de validación`)),
            " ",
            !item.hoponHopoff && !item.vuelta && React.createElement("h6", null,
                React.createElement("p", { style: { textAlign: 'center' } }, 'Válido para un solo uso')),
            " ",
            !item.hoponHopoff && item.vuelta && React.createElement("h6", null,
                React.createElement("p", { style: { textAlign: 'center' } }, 'Válido para un solo uso de ida y vuelta')),
            " ",
            item.hoponHopoff && !item.datebook && item.timeExpiration === 0 &&
                React.createElement("h6", null,
                    React.createElement("p", { style: { marginTop: 0, marginBottom: 0, textAlign: 'center' } },
                        T('validoPara'),
                        " ",
                        toDate(expiration))),
            item.hoponHopoff && !item.datevalited && item.timeExpiration > 0 &&
                React.createElement("h6", null,
                    React.createElement("p", { style: { marginTop: 0, marginBottom: 0, textAlign: 'center' } },
                        T('paraUsarEntre'),
                        " ",
                        toDate(book),
                        " ",
                        T('yEl'),
                        " ",
                        toDate(expiration))),
            item.hoponHopoff && item.datevalited && item.timeExpiration > 0 &&
                React.createElement("h6", null,
                    React.createElement("p", { style: { marginTop: 0, marginBottom: 0, textAlign: 'center' } },
                        T('paraUsarHasta'),
                        " ",
                        item.datevalited ? toDateTime(expiration) : toDate(expiration))),
            !item.hoponHopoff && item.datebook && fechasIguales(typeof book === 'string' ?
                new Date(book) : book, expiration) && React.createElement("h6", null,
                React.createElement("p", { style: { marginTop: 0, marginBottom: 0, textAlign: 'center' } },
                    T('parael'),
                    " ",
                    toDate(expiration))),
            !item.hoponHopoff && item.datebook && !fechasIguales(typeof book === 'string' ?
                new Date(book) : book, expiration) && React.createElement("h6", null,
                React.createElement("p", { style: { marginTop: 0, marginBottom: 0, textAlign: 'center' } },
                    T('desde'),
                    " ",
                    toDate(book),
                    " ",
                    T('hasta'),
                    " ",
                    toDate(expiration)))));
    }
};
const renderIdaVuelta = () => {
    return (React.createElement("div", null,
        React.createElement("h2", null,
            React.createElement("p", { style: { marginTop: 0, marginBottom: 0, textAlign: 'center' } }, 'IDA')),
        React.createElement("h2", null,
            React.createElement("p", { style: { textAlign: 'center' } }, 'VUELTA'))));
};
const fechasIguales = (date1, date2) => {
    return date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate();
};
{ /*<p style={{margin: 0, padding: 0, fontSize: 25, width: '100%'}}>...................................................</p>*/ }



//////////////////
// WEBPACK FOOTER
// ./src/modules/Reports/components/Papel.tsx
// module id = 239
// module chunks = 0